import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import { SwModalframeComponent } from '../../../basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $: any;

@Component({
  selector: 'app-sw-all-user-modal',
  templateUrl: './sw-all-user-modal.component.html',
  styleUrls: ['./sw-all-user-modal.component.css']
})
export class SwAllUserModalComponent implements OnInit {

  /**
   * 动态创建组件传入的参数, 要含有 userId 这个数组
   */
  @Input() param 

  /**
   * 动态创建组件的抛出事件
   */
  @Output() callback = new EventEmitter(); 

  /**
   * 模态框
   * @ignore
   */
  @ViewChild('userModal') userModal: SwModalframeComponent; 

  /**
   * 是否展示左侧菜单
   * @ignore
   */
  showLeft:boolean = true 

  /**
   * 根据筛选条件出现的用户
   * @ignore
   */
  userList:any[] =[] 

  /**
   * 勾选的用户
   * @ignore
   */
  checkedUser:any[] 

  /**
   * 左侧的筛选条件,可以使组织,岗位或角色
   * @ignore
   */
  filter:string = "department" 

  /**
   * 组织树列表
   * @ignore
   */
  departmentTree:any[] = []  

  /**
   * 角色树列表
   * @ignore
   */
  roleTree:any[] = []  

  /**
   * 岗位树列表
   * @ignore
   */
  positionTree:any[] = []  

  /**
   * 查询条件
   * @ignore
   */
  selectData:any = {displayName:""}

  /**
   * 模态框确认按钮状态,是否置灰,默认置灰
   * @ignore
   */
  disabled:boolean = true

  /**
   * 模态框标题，默认是 "审批人区域"
   * @ignore
   */
  headerLogo:string = "审批人区域"

  /**
   * 模态框选值是否是必填项，默认是2-->必填项，不选择用户点击确定会提示，如果是1-->不是必填，那么不选用户也可以点击确定
   * @ignore
   */
  required:number = 2

  constructor(
    private systemId:SystemIdService,
    private bdpService: BdpService, //请求服务
    private el:ElementRef,
    private renderer2:Renderer2,
    private http: SwHttpClientService, //http请求
    private box: SwMassageBoxService,  //消息提示服务
    ) { }

  ngOnInit() {
    if(this.param.userId){
      this.checkedUser = JSON.parse(JSON.stringify(this.param.userId))
    }
    if(this.param.required){
      this.required = this.param.required
    }
    if(this.param.headerLogo){
      this.headerLogo = this.param.headerLogo
    }
    //获取所有用户
    this.getUser()
    //获取左侧组织
    this.getDepartment()
    //获取左侧岗位
    this.getPosition()
    //获取左侧角色
    this.getRole()
  }

  //首次获取所有用户
  getUser(){
    //获取用户
    var Check = $("input[name='user']");
    //然后全部取消选择
    Check.prop("checked", false)
    let param1 = {systemId: this.systemId.getSystemId()}
    this.bdpService.getUserService().queryList(param1).subscribe( //查询用户
      data => {
        if (data["code"] == 200) {
          let arr1 = []
          let result = data["data"]
          result.forEach(user => {
            if(user.status){
              let checked = this.checkedUser.indexOf(user.userId) != -1
              arr1.push({id:user.userId,text:user.displayName,checked:checked})
            }
          });
          this.userList = arr1
        }
      }
    )
  }
  
  //改变复选框事件
  checKboxChange(event) {
    //判读是否选中
    if (event.target.checked) {
      //选中数据 保存 
      this.checkedUser.push(event.target.id);
    } else {
      //选中数据  如果是取消 则在选择数组中 删除掉数据
      let index = this.checkedUser.indexOf(event.target.id)
      if( index != -1){  //该用户在勾选的数组中不存在,就加进去
        this.checkedUser.splice(index, 1);
      }
    }
    if(this.checkedUser.length){
      //如果还存在勾选的用户就可以点击确认按钮
      this.disabled = false
    } else {
      //如果没有勾选用户就将确认按钮置灰
      this.disabled = true
    }
  }

  //获取左侧角色树
  getRole(){
    let param2 = {systemId: this.systemId.getSystemId()}
    this.bdpService.getRoleService().queryList(param2).subscribe(  //请求角色数据
      data => {
        if (data["code"] == 200) {
          let arr1 = [];
          //获取到的数组中没有id text pid字段,所以要处理一下数据,转化为树组件所需要的格式
          data["data"]["records"].forEach(e => {
            arr1.push({ id: e.roleId, text: e.roleName, pid: 'Yiji',isAdmin:e.isAdmin })
          });
          this.roleTree = arr1
        }
      }
    )
  }

  //获取左侧岗位树
  getPosition(){
    let param3 = {systemId: this.systemId.getSystemId() }
    this.bdpService.getPositionService().queryList(param3).subscribe(data => {
      if (data["code"] == 200) {
        //数组中自带了 id text pid字段,不需要处理
        this.positionTree = data["data"]["records"]
      }
    });
  }

  //获取左侧组织树
  getDepartment() {
    let systemId = this.systemId.getSystemId()//拿系统id
    let Params =  { systemId: systemId } //取所有组织管理数据
    this.bdpService.getDepartmentService().queryList(Params).subscribe(data => {
      if (data["code"] == 200) { //请求成功
        //数组中自带了 id text pid字段,不需要处理
        this.departmentTree = data["data"]["records"];
      }
    });
  }


  //组织树的选中结果
  onVotedDepartment(event){
    //根据组织查询用户
    let param = { "param": { pageSize: 0,systemId:this.systemId.getSystemId() }, "organizeId": event.key,lazy:false, "entity":{} }
    this.bdpService.getCommonService().queryUserByOrganizeId(param).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]["records"]
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,checked:checked})
          }
        });
        this.userList = temp
      }
    })
  }

  //角色树的选中结果
  onVotedRole(event){
    //根据角色查询用户
    let param = { "param": { pageSize: 0 },  "entity": {"roleId": event.key,systemId:this.systemId.getSystemId()} }
    this.bdpService.getUserService().queryUserByRoleId(event.key,this.systemId.getSystemId()).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,checked:checked})
          }
        });
        this.userList = temp
      }
    })
    
  }

  //岗位树的选中结果
  onVotedPosition(event){
    let param = { "param": { pageSize: 0,systemId:this.systemId.getSystemId() }, "positionId": event.key, "entity":{}}
    this.bdpService.getUserService().queryUserByPositionId(param).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]["records"]
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,checked:checked})
          }
        });
        this.userList = temp
      }
    })
    
  }

  //全选/反选
  clickChecedAll(event){
    if (event.target.checked) {
      //全选
      this.userList.forEach(user => {
        user.checked = true
        let index = this.checkedUser.indexOf(user.id)
        if( index == -1){  //该用户在勾选的数组中不存在,就加进去
          this.checkedUser.push(user.id)
        }
      });
      //全选之后可以点击确认按钮了
      this.disabled = false
    } else {
      //取消全选
      for (let i = this.userList.length-1; i >= 0 ; i--) {
        this.userList[i].checked = false
        let index = this.checkedUser.indexOf(this.userList[i].id)
        if( index != -1){  //该用户在勾选的数组中不存在,就加进去
          this.checkedUser.splice(index, 1);
        }
      }
      //取消全选之后不能点击确认按钮了
      this.disabled = true
    }
  }
  //查询--根据 displayName 进行查询
  clickSelect(){
    let param = { "param": { pageSize: 0 }, "entity": { displayName: this.selectData.displayName,systemId: this.systemId.getSystemId() } }
    this.bdpService.getUserService().queryUserPageList(param).subscribe(data => {
      let temp = [];
      if (data["code"] == 200) {
        let result = data["data"]["records"]
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,checked:checked})
          }
        });
        this.userList = temp
      }
    })
  }

  //重置
  clickreload(){
    this.getUser()
    let spans = this.el.nativeElement.querySelectorAll('span')
    spans.forEach(element => {
      this.renderer2.removeClass(element,'tree-selected')  //左侧选中样式全都清空
    });
  }

  //点击指定执行人模态框的确认按钮
  sureOperator(){
    if(this.required == 2){
      //如果是必填项
      if(!this.disabled){
        this.userModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
        this.callback.emit(this.checkedUser)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
      }else {
        this.box.danger('请选择指定执行人')
      }
    } else if(this.required == 1){
      this.userModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
      this.callback.emit(this.checkedUser)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
    }
    
  }

  //点击关闭模态框
  closeOperatorModal(){
    this.userModal.toggle() //关闭模态框
    this.callback.emit(false)  //抛出false, 只销毁组件,什么都不做
  }

  //隐藏左边面板
  showStyle(data) {
    this.showLeft=!data;
  }
}
